import React, { FC } from 'react';
import { ActionsGridItem, ActionsGridItemProps } from './ActionsGridItem';
import styles from './ActionsGrid.scss';

type Props = {
  items: ActionsGridItemProps[];
};

export const ActionsGrid: FC<Props> = ({ items }) => {
  return (
    <div className={styles.actionsGrid}>
      {items.map((item) => (
        <ActionsGridItem key={item.title} {...item} />
      ))}
    </div>
  );
};
